module.exports = "<svg viewBox=\"0 0 10 10\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#979797\" fill-rule=\"evenodd\"><path d=\"M8.07.293L.294 8.07l1.414 1.415 7.778-7.778L8.07.293z\"></path><path d=\"M.293 1.707L8.07 9.485 9.486 8.07 1.706.294.294 1.707z\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/svg-inline-loader!./client/components/Categories/Moving/delete.svg
// module id = 1993
// module chunks = 0